const CURRENCY_DECIMALS = {
    // ZERO_DECIMAL_CURRENCIES
    IDR: 1,
    JPY: 1,
    KRW: 1,
    VND: 1,
    BYR: 1,
    CVE: 1,
    DJF: 1,
    GHC: 1,
    GNF: 1,
    KMF: 1,
    PYG: 1,
    RWF: 1,
    UGX: 1,
    VUV: 1,
    XAF: 1,
    XOF: 1,
    XPF: 1,

    // ONE_DECIMAL_CURRENCIES
    MRO: 10,

    // THREE_DECIMAL_CURRENCIES
    BHD: 1000,
    IQD: 1000,
    JOD: 1000,
    KWD: 1000,
    OMR: 1000,
    LYD: 1000,
    TND: 1000
};

export default CURRENCY_DECIMALS;
